/* eslint-disable react/display-name */
import classNames from 'classnames';
// import { memo, useState } from 'react';
import { memo, useState, useEffect } from 'react';
import styles from './quantityInput.module.scss';

const QuantityInputBox = memo((props) => {
  // const { quantity, defaultValue = 1 } = props;
  const { quantity, defaultValue = 1, min = 0, max = 100 } = props;
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const decrement = () => {
    // const nv = value <= 0 ? 0 : value - 1;
    const current = parseInt(value, 10) || min;
    const nv = current <= min ? min : current - 1;
    setValue(nv);
    quantity?.(nv);
  };

  const increment = () => {
    // const nv = value + 1;
    const current = parseInt(value, 10) || min;
    const nv = current >= max ? max : current + 1;
    setValue(nv);
    quantity?.(nv);
  };

  const handleChange = (e) => {
    const val = e?.target?.value;
    if (val === '') {
      setValue('');
      return;
    }
    const num = parseInt(val.replace(/\D/g, ''), 10);
    if (isNaN(num)) return;
    const clamped = Math.min(Math.max(num, min), max);
    setValue(clamped);
    quantity?.(clamped);
  };

  const handleBlur = () => {
    if (value === '' || parseInt(value, 10) < min) {
      setValue(min);
      quantity?.(min);
    } else if (parseInt(value, 10) > max) {
      setValue(max);
      quantity?.(max);
    }
  };

  return (
    <div className={styles['quantity-input']}>
      <button
        className={classNames(
          styles['quantity-input__modifier'],
          styles['quantity-input__modifier--right']
        )}
        onClick={() => decrement()}
        disabled={parseInt(value, 10) <= min}
      >
        &mdash;
      </button>
      <input
        className={styles['quantity-input__screen']}
        type="text"
        value={value}
        // onChange={(e) => setValue(e?.target?.value)}
        onChange={handleChange}
        onBlur={handleBlur}
        // readOnly={!!value}
      />
      <button
        className={classNames(
          styles['quantity-input__modifier'],
          styles['quantity-input__modifier--left']
        )}
        onClick={() => increment()}
        disabled={parseInt(value, 10) >= max}
      >
        &#xff0b;
      </button>
    </div>
  );
});

export default QuantityInputBox;
